import * as React from "react";
import { useEffect } from "react";
import { PageProps } from "gatsby";
import * as styles from "./styles.module.scss";
import { StaticImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { Breadcrumb } from "../../../components/breadcrumb/breadcrumb";
import Layout from "../../../components/layout/layout";
import Container from "../../../components/container/container";
import Heading from "../../../components/basic-components/heading/heading";
import { ProductBar } from "../../../components/product-bar/product-bar";
import { Level } from "react-accessible-headings";
import scrollTo from "gatsby-plugin-smoothscroll";
import { Helmet } from "react-helmet";
import blogImage from "../../../images/cozum/alerjik-oksuruk/Content-image.webp";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const CoughPage: React.FC<PageProps> = ({ location }: PageProps) => {
  useEffect(() => {
    if (location.hash) {
      scrollTo(location.hash);
    }
  }, []);
  return (
    <Layout
      stickyHeader={false}
      seoConfig={{
        title: "Alerjik Öksürük Nedir Ne İyi Gelir?",
        description:
          "Alerjik Öksürük Nedir, Nedenleri Nelerdir? Alerjik Öksürüğe Ne İyi Gelir? gibi soruların yanıtlarını bulmak için sayfamızı ziyaret edin!",
      }}
    >
      <Helmet>
        <script type="application/ld+json">
          {`
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {"@type": "ListItem","position": 1,"name": "Ana Sayfa","item": "https://www.bisolnatur.com.tr/"},
                  {"@type": "ListItem","position": 2,"name": "Öksürük","item": "https://www.bisolnatur.com.tr/oksuruk/"},
                  {"@type": "ListItem","position": 3,"name": "Alerjik Öksürük Nedir Ne İyi Gelir?","item": "https://www.bisolnatur.com.tr/oksuruk/alerjik-oksuruk-nedir-ne-iyi-gelir/"}
                ]
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "${location.href}"
              },
              "headline": "Alerjik Öksürük Nedir Ne İyi Gelir?",
              "image": "${location.origin + blogImage}",  
              "author": {
                "@type": "Organization",
                "name": "Bisolnatur",
                "url": "${location.origin}"
              },  
              "publisher": {
                "@type": "Organization",
                "name": "Bisolnatur",
                "logo": {
                  "@type": "ImageObject",
                  "url": "${location.origin}/logo.svg"
                }
              },
              "datePublished": "2022-01-27",
              "dateModified": "2022-01-27"
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"Alerjik Öksürük Nedir?","acceptedAnswer":{"@type":"Answer","text":"Alerjiler, öksürüğe neden olabilir. Tipik olarak hapşırma, burun tıkanıklığı, gözlerde kaşıntı ve kurdeşen ile kendisini gösteren alerjenler, özellikle saman nezlesi alerjenleri, boğazı ve akciğerleri tahriş edebilir ve öksürük oluşumuna neden olabilir. Alerjenler, boğazınızdan aşağı inen ve kalıcı bir kuru öksürüğe yol açabilecek tahrişe neden olan bir geniz akıntısına neden olur. "}},{"@type":"Question","name":"Alerjik Öksürük Belirtileri Nelerdir?","acceptedAnswer":{"@type":"Answer","text":"Kronik kuru öksürüğünüz varsa (üç haftadan uzun süren bir öksürük türüdür), bu alerji veya astım belirtisi olabilir. Eğer öksürük alerji kaynaklıysa bazı mevsimlerde veya bazı ortamlarda daha çok öksürdüğünüzü fark edebilirsiniz. Bu, sizi etkileyebilecek alerjenlerin varlığından kaynaklanabilir. Kişinin öksürüğe yakalandığı ortamlarda dikkat etmesi ve o tip ortamlarda bulunmaması kişinin uzun dönem sağlığı açısından önem teşkil etmektedir. Alerjinizi tetikleyen alerjenlerden uzak durulması gerekmektedir."}},{"@type":"Question","name":"Alerjik Öksürüğün Nedenleri Nelerdir?","acceptedAnswer":{"@type":"Answer","text":"Alerjik öksürüğün temel nedenleri vücudun maruz kaldığı alerjik yanıt oluşumuna sebep olan maddelerdir. Bu maddeler kişiden kişiye değişmekle birlikte vücudun verdiği tepkiler arasında benzerlikler bulunur. Vücut zararsız maddeleri zararlı maddelerle karıştırdığında ve sonrasında onları vücuttan uzaklaştırmak için savunma sistemini harekete geçirdiğinde ortaya çıkar. Bu vücudun alarm durumuna geçmesine ve çeşitli önlemler almasına sebebiyet verir. Böylece, kişinin soğuk algınlığında vücudun serbest bıraktığı histamin adı verilen kimyasalın salınmasına neden olur. Histamin, burun akıntısı, öksürme, hapşırma gibi semptomları oluşturur ve bu nedenle hasta soğuk algınlığı olmadığı halde soğuk algınlığı benzeri semptomlar yaşamaya başlar."}},{"@type":"Question","name":"Alerjik Öksürük Ne Kadar Sürer?","acceptedAnswer":{"@type":"Answer","text":"Alerji kaynaklı olan öksürük süreleri alerjen etkenine kişinin ne kadar süre maruz kaldığına bağlı olarak değişebilmektedir. Genel olarak 2-3 haftadan uzun süren öksürükler alerjik öksürük olarak tanımlanır. "}}]}
          `}
        </script>
      </Helmet>
      <Breadcrumb
        pathname={location.pathname}
        noBg={true}
        className={styles.breadcrumb}
      />
      <Container fullWidth>
        <div className={classNames(styles.header)}>
          <StaticImage
            className={styles.image}
            src="../../../images/cozum/alerjik-oksuruk/Content-image.webp"
            alt="Öksüren kadın görseli"
            width={1680}
            height={450}
          />
          <Container>
            <Heading>
              Alerjik Öksürük Nedir Ne İyi
              <br />
              Gelir?
            </Heading>
            <ul>
              <li>
                <AnchorLink
                  className="blue"
                  to="#oksuruk-nedir"
                  title="Öksürük Nedir?"
                >
                  Öksürük Nedir?
                </AnchorLink>
              </li>
              <li>
                <AnchorLink
                  className="blue"
                  to="#oksurugun-nedenleri-nelerdir"
                  title="Öksürüğün Nedenleri Nelerdir? "
                >
                  Öksürüğün Nedenleri Nelerdir?
                </AnchorLink>
              </li>
              <li>
                <AnchorLink
                  className="blue"
                  to="#alerjik-oksuruk-nedir"
                  title="Alerjik Öksürük Nedir?"
                >
                  Alerjik Öksürük Nedir?
                </AnchorLink>
              </li>
              <li>
                <AnchorLink
                  className="blue"
                  to="#alerjik-oksuruk-belirtileri-nelerdir"
                  title="Alerjik Öksürük Belirtileri Nelerdir?"
                >
                  Alerjik Öksürük Belirtileri Nelerdir?
                </AnchorLink>
              </li>
              <li>
                <AnchorLink
                  className="blue"
                  to="#alerjik-oksurugun-nedenleri-nelerdir"
                  title="Alerjik Öksürüğün Nedenleri Nelerdir?"
                >
                  Alerjik Öksürüğün Nedenleri Nelerdir?
                </AnchorLink>
              </li>
              <li>
                <AnchorLink
                  className="blue"
                  to="#alerjik-oksuruk-ne-kadar-surer"
                  title="Alerjik Öksürük Ne Kadar Sürer?"
                >
                  Alerjik Öksürük Ne Kadar Sürer?
                </AnchorLink>
              </li>
              <li>
                <AnchorLink
                  className="blue"
                  to="#alerjik-oksuruk-icin-ne-iyi-gelir"
                  title="Alerjik Öksürük İçin Ne İyi Gelir? "
                >
                  Alerjik Öksürük İçin Ne İyi Gelir?
                </AnchorLink>
              </li>
            </ul>
          </Container>
        </div>
      </Container>
      <Container>
        <div className={styles.holder}>
          <p id="oksuruk-nedir" className="extra-bold">
            Öksürük, insanlarda sıklıkla görülebilen bir semptom olarak kabul
            edilir. Öksürüğün sıklığı, süresi ve varsa eşlik eden diğer
            belirtiler ile birlikte değerlendirilir ve tanısı konulduktan sonra
            tedavi süreci başlar. Farklı sebeplerden kaynaklı çeşitli türde
            öksürük tipleri mevcuttur.
          </p>
          <section className={styles.kidsHolder}>
            <Level>
              <h2 className="orange underline">Öksürük Nedir?</h2>
              <p>
                Öksürük, boğaz veya solunum yollarını tahriş eden bir durum
                olduğunda, vücudun buna tepki verme şekli olarak tanımlanır.
                Tahriş edici bu etken, beyne mesaj gönderen sinir sistemini
                uyarır. Beyin daha sonra göğsünüzdeki ve karnınızdaki kaslara
                tahriş edici maddeyi dışarı atmak için akciğerlerinizdeki
                havanın dışarı atılması gerektiğini iletir. Bu şekilde kişide
                öksürük eylemi başlamış olur.
                <br />
                <br />
                Ara sıra kişilerde meydana gelebilecek olan öksürük normal ve
                sağlıklıdır. Bu tip zamanlarda endişelenecek bir durum bulunmaz.
                Fakat, birkaç hafta aralıklı ya da sürekli devam eden, renksiz
                veya kanlı mukus getiren bir öksürük, tıbbi müdahale gerektiren
                bir duruma işaret edebilir. Kişinin belirtileri takip etmesi ve
                gerektiğinde hastaneye başvurması gerekebilir.
                <br />
                <br />
                Bazen öksürük çok güçlü olabilir ve bu durum kişinin yaşam
                kalitesini düşürebilir. Uzun süren, şiddetli öksürük boğazları
                tahriş edebilir ve bu da daha fazla öksürüğe neden olur. Ayrıca
                süresine ve şiddetine bağlı olarak da yorgunluk, uykusuzluk, baş
                dönmesi veya bayılma, baş ağrısı, idrar tutamama, kusma ve hatta
                öksürüğün şiddetine bağlı olarak kaburgaların çeşitli travmalara
                neden olabilir. Ancak çoğunlukla öksürük kendiliğinden geçen bir
                durumdur ve herhangi bir tedavi ihtiyacı bulunmaz.
              </p>
              <Level>
                <Heading id="oksurugun-nedenleri-nelerdir">
                  Öksürüğün Nedenleri Nelerdir?
                </Heading>
              </Level>
              <p>
                Öksürüğün birden çok sebebi olabilir. Öksürük, kronik ve akut
                öksürük olarak ikiye ayrılmaktadır. Kronik öksürük tanım olarak
                uzun süredir devam eden öksürüğü tanımlar iken, akut öksürük ani
                gelişen ve kısa süre boyunca devam eden öksürüğü tanımlamak için
                kullanılır. Kronik ve akut öksürüğün nedenleri kendi içlerinde
                farklılıklar gösterir.
                <br />
                <br />
              </p>
              <StaticImage
                className={styles.image}
                src="../../../images/cozum/alerjik-oksuruk/img.webp"
                alt="Metroda öksüren kadın görseli"
                width={792}
                height={430}
              />
              <p>
                Kronik öksürük için en sık rastlanan sebepleri aşağıda
                sıralanmıştır:
              </p>
              <ul>
                <li className="blue">Astım (En sık çocuklarda görülür.)</li>
                <li className="blue">Kronik bronşit</li>
                <li className="blue">Gastroözofageal reflü</li>
                <li className="blue">Sigara tüketimi</li>
              </ul>
              <p>Akut öksürüğün en sık rastlanan sebepleri arasında:</p>
              <ul>
                <li className="blue">Nezle, soğuk algınlığı,</li>
                <li className="blue">Grip,</li>
                <li className="blue">
                  Tahriş edici bir maddenin solunması (duman, toz, kimyasal
                  maddeler veya yabancı cisim gibi),
                </li>
                <li className="blue">
                  Alt solunum yolu enfeksiyonları (ASYE) veya üst solunum yolu
                  enfeksiyonları (ÜSYE),
                </li>
                <li className="blue">Farklı tipteki alerjiler,</li>
                <li className="blue">
                  Astım, kronik obstrüktif akciğer hastalığı (KOAH) veya kronik
                  bronşit gibi hastalıkların çeşitli sebeplerden ötürü tekrar
                  alevlenmesi olarak sıralanabilir.{" "}
                </li>
              </ul>
              <p>
                Alerji semptomları hafif, orta veya şiddetli olarak kuvvetinde
                değişiklik gösterebilir. Mevsimsel olarak ortaya çıkabilir veya
                yıl boyunca devam edebilir.
              </p>
              <p>
                Astım hastalığı bulunan hastalarda alerjiler öksürük, hırıltı ve
                nefes darlığına neden olabilir. Kişinin nefes almasını
                zorlaştırabilir ve günlük hayatındaki yaşam kalitesinde düşüş
                olabilir. Tanım olarak alerjiler, bağışıklık sisteminizin
                çevrenizde bulunan polen, toz, küf ve evcil hayvan tüyü gibi
                maddeler ile karşılaştığında normalden daha fazla tepki
                vermesinden kaynaklanır. Vücudun verdiği tepkilerin başında da
                öksürük gelmektedir.
              </p>
              <p>
                Alerji belirtileri arasında yaygın olarak rastlanılanları
                aşağıda sıralanmıştır:
              </p>
              <ul>
                <li className="blue">Hapşırma,</li>
                <li className="blue">Burun akıntısı veya tıkalı burun</li>
                <li className="blue">Kaşıntılı veya sulu gözler</li>
                <li className="blue">Kaşıntılı burun veya kulaklar</li>
                <li className="blue">
                  Burun akıntısı ( bazen hafif bir boğaz ağrısına neden
                  olabilir. )
                </li>
                <li className="blue">Hafif yorgunluk</li>
              </ul>
            </Level>
          </section>
          <section id="alerjik-oksuruk-nedir" className={styles.typesHolder}>
            <Level>
              <Level>
                <Heading>Alerjik Öksürük Nedir?</Heading>
              </Level>
              <p>
                Alerjiler, öksürüğe neden olabilir. Tipik olarak hapşırma, burun
                tıkanıklığı, gözlerde kaşıntı ve kurdeşen ile kendisini gösteren
                alerjenler, özellikle saman nezlesi alerjenleri, boğazı ve
                akciğerleri tahriş edebilir ve öksürük oluşumuna neden olabilir.
                Alerjenler, boğazınızdan aşağı inen ve kalıcı bir kuru öksürüğe
                yol açabilecek tahrişe neden olan bir geniz akıntısına neden
                olur. Durumun kontrol edilmesi ve takip edilmesinde yarar vardır
                çünkü bu belirtiler aynı zamanda astım hastalığının da
                belirtilerinden biridir. Tanıyı doğru koymak tedavinin de
                sürecini değiştireceğinden, kişilerin kendilerinde oluşan
                belirtileri yakından takip etmesi ve farkında olmaları gerekir.
              </p>
              <p>
                Alerjik öksürük genel tanım olarak, alerjilerin neden olduğu
                öksürüğün, soğuk algınlığından kaynaklanan öksürükten ayırt
                etmek için kullanılan bir terimdir. Alerjik öksürük, bu
                hastalıklar gibi belirli bir enfeksiyondan ziyade immun sistemin
                vücudun karşılaştığı bir alerjene verdiği yanıttan kaynaklanır.
                Bu yüzden belirtileri aynı olsa da tanı ve tedavilerinde
                farklılıkları bulunmaktadır. Örneğin, astım da öksürüğe neden
                olabilir. Ayrıca hırıltılı nefes alıyorsanız veya göğsünüzde
                sıkışma veya nefes darlığı çekiyorsanız, astım öksürüğünü de
                olabilir. Öksürüğe genellikle burun akıntısı ve burun
                tıkanıklığı eşlik eder ve bu semptomlar, kişi soğuk algınlığına
                veya alerjik reaksiyona sahip olduğunda aynı anda ortaya çıkar.
                Hastalar buna tam olarak neyin neden olduğundan emin
                olamadıkları için öksürüğü teşhis etmek ve tedavi sürecini doğru
                belirleyebilmek bazen zor olabilmektedir. Sonuç olarak, hastalar
                yanlış ilaçlar alabilir veya uygun tıbbi yardım alamayabilirler.
              </p>
              <p>
                Alerjik öksürük, hava yollarının alerjen etkenine bağlı olarak
                normalden daha fazla şişmesine ve öksürüğe bağlı olarak boğaz
                yolunun tahrişine sebep olmaktadır. Bu nedenle de alerjik
                öksürük, dış etkenlerden büyük ölçüde etkilenir. Dış etkenlere
                bağlı olarak öksürüğün şiddetinde ve süresinde değişiklikler
                gözlenebilir. Alevlenmelerin normalden daha da kötüleşmesine
                yoğun bir polen mevsimi ya da küflü yeni bir ortama taşınmak
                neden olabilir. Saman nezlesi gibi alerjiler kronik kuru
                öksürüğe neden olabilir. Toz, evcil hayvan tüyü, polen, küf veya
                diğer yaygın alerjenlere karşı hassas iseniz, alerji
                belirtileriniz arasında öksürük olabilir. Alerjiler ayrıca astım
                semptomlarını kötüleştirebilir ve daha şiddetli olarak ortaya
                çıkmasına neden olabilir.
              </p>
              <p>
                Soğuk algınlığı ve alerjik öksürük arasındaki öksürüğün
                semptomları arasında çeşitli farklılıklar bulunur. En belirgin
                olanları öksürük süresi ve semptomların görüldüğü dönem olarak
                söylenebilir. Öksürük oluşumunun temel sebebi ortamdaki
                alerjenlerin mevcudiyeti olduğu için kişinin öksürük süreleri de
                değişiklik gösterebilmektedir. Soğuk algınlığından kaynaklanan
                öksürük ise genellikle kış mevsimlerinde görülür. Kişi alerjene
                maruz kaldığı anda başlayan ani semptomlara neden olur.
              </p>
              <StaticImage
                className={styles.image}
                src="../../../images/cozum/alerjik-oksuruk/young-asian-woman-having-a-cough-sore-throat-and-2021-10-06-09-53-01-utc.webp"
                alt="Öksürük ğrısı sebebiyle boğazını tutaan genç kadın görseli"
                width={792}
                height={430}
              />
            </Level>
          </section>
          <section
            id="alerjik-oksuruk-belirtileri-nelerdir"
            className={styles.typesHolder}
          >
            <Level>
              <Level>
                <Heading>Alerjik Öksürük Belirtileri Nelerdir?</Heading>
              </Level>
              <p>
                Kronik kuru öksürüğünüz varsa (üç haftadan uzun süren bir
                öksürük türüdür), bu alerji veya astım belirtisi olabilir. Eğer
                öksürük alerji kaynaklıysa bazı mevsimlerde veya bazı ortamlarda
                daha çok öksürdüğünüzü fark edebilirsiniz. Bu, sizi
                etkileyebilecek alerjenlerin varlığından kaynaklanabilir.
                Kişinin öksürüğe yakalandığı ortamlarda dikkat etmesi ve o tip
                ortamlarda bulunmaması kişinin uzun dönem sağlığı açısından önem
                teşkil etmektedir. Alerjinizi tetikleyen alerjenlerden uzak
                durulması gerekmektedir.
              </p>
              <p>
                Bununla birlikte, alerjik öksürük ve diğer alerji semptomları da
                zamanla değişiklik gösterebilir. Daha öncesinde alerjik
                reaksiyon göstermediğiniz bir duruma alerjik reaksiyon
                gösterebilirsiniz. Ya da yaş ilerledikçe insanlar, alerjenlere
                maruz kaldıklarında bile semptomlarının daha az yaygın hale
                geldiğini fark eder. Bunun başlıca nedeni, bağışıklık sisteminin
                zayıflaması ve eskisi kadar güçlü tepki verememesidir. Ancak bu,
                alerjinin kendisinin kişinin vücudunda oluşmadığı anlamına
                geldiği çıkarılmamalıdır.
              </p>
            </Level>
          </section>
          <section
            id="alerjik-oksurugun-nedenleri-nelerdir"
            className={styles.kidsHolder}
          >
            <Level>
              <Level>
                <Heading>Alerjik Öksürüğün Nedenleri Nelerdir?</Heading>
                <p>
                  Alerjik öksürüğün temel nedenleri vücudun maruz kaldığı
                  alerjik yanıt oluşumuna sebep olan maddelerdir. Bu maddeler
                  kişiden kişiye değişmekle birlikte vücudun verdiği tepkiler
                  arasında benzerlikler bulunur. Vücut zararsız maddeleri
                  zararlı maddelerle karıştırdığında ve sonrasında onları
                  vücuttan uzaklaştırmak için savunma sistemini harekete
                  geçirdiğinde ortaya çıkar. Bu vücudun alarm durumuna geçmesine
                  ve çeşitli önlemler almasına sebebiyet verir. Böylece, kişinin
                  soğuk algınlığında vücudun serbest bıraktığı histamin adı
                  verilen kimyasalın salınmasına neden olur. Histamin, burun
                  akıntısı, öksürme, hapşırma gibi semptomları oluşturur ve bu
                  nedenle hasta soğuk algınlığı olmadığı halde soğuk algınlığı
                  benzeri semptomlar yaşamaya başlar.
                </p>
                <p>
                  Tüm alerjik reaksiyonların birden çok sebebi olabilmektedir,
                  bazı kişiler bu duruma daha yatkın immun sisteme sahiptir.
                  Ailesinde alerjik öykü hikayesi olan kişilerde alerjik öksürük
                  geliştirme şansı daha yüksektir. Alerjik öksürüğün başlıca
                  nedenleri aşağıdaki gibi sıralanabilir:
                </p>
                <ul>
                  <li className="blue">
                    Solunan bir maddeye karşı reaksiyon (alerjen olarak
                    adlandırılır). En sıklıkla karşılaşılan sebebi polendir.
                  </li>
                  <li className="blue">
                    Otlar, ağaçlar, yabani otlar ve küfler en yaygın
                    nedenlerdendir
                  </li>
                  <li className="blue">
                    Alerjenler ayrıca kedilerden, köpeklerden, atlardan,
                    tavşanlardan ve diğer hayvanlardan dolayı kaynaklanıyor
                    olabilir.
                  </li>
                  <li className="blue">
                    Toz, kimyasallar veya hava kirliliği de öksürüğe neden
                    olabilir. Ancak bu, alerjik bir reaksiyon değil, hava
                    yolunun tahrişinden kaynaklanır.
                  </li>
                </ul>
              </Level>
            </Level>
          </section>
          <section
            id="alerjik-oksuruk-ne-kadar-surer"
            className={styles.kidsHolder}
          >
            <Level>
              <Level>
                <Heading>Alerjik Öksürük Ne Kadar Sürer?</Heading>
                <p>
                  Alerji kaynaklı olan öksürük süreleri alerjen etkenine kişinin
                  ne kadar süre maruz kaldığına bağlı olarak değişebilmektedir.
                  Genel olarak 2-3 haftadan uzun süren öksürükler alerjik
                  öksürük olarak tanımlanır. Alerjik öksürüğün nedenleri çok
                  çeşitli olabildiği için öksürük süreleri de alerjen türüne
                  bağlı olarak değişebilmektedir. Dönemsel alerjiler, buna sebep
                  olan alerji etkeninin ortadan kalkmasına kadar öksürük kişide
                  devam edebilmektedir. Toz ve ev akarlarına karşı oluşan bir
                  alerjiden kaynaklı öksürükler de ise ortam değişikliği ya da
                  temizlik ile birlikte kişide daha kısa sürede öksürüklerinde
                  azalma görülebilir. Sürenin azaltılmasında alerjik öksürük
                  kaynağının bilinmesi sürecin kontrol altına alınmasında ve
                  iyileşme sürecinin azaltılmasında oldukça önemlidir.
                </p>
              </Level>
            </Level>
          </section>
          <section
            id="alerjik-oksuruk-icin-ne-iyi-gelir"
            className={styles.kidsHolder}
          >
            <Level>
              <Level>
                <Heading>Alerjik Öksürük İçin Ne İyi Gelir? </Heading>
                <p>
                  <br />
                  Medikal tedavilerin yanı sıra alerjik öksürük için destek
                  tedavileri de mevcuttur. Alerjik öksürük dönemlerinde:
                </p>
                <ul>
                  <li className="blue">
                    Su tüketimi oldukça önemlidir, bu dönemlerde bol sıvı
                    tüketilmesine dikkat edilmelidir. Sıvı tüketimi ile boğazda
                    oluşan mukusun incelmesine sağlanır ve vücuttan atılımı
                    kolaylaşır. Ayrıca öksürük sonucunda boğazda oluşabilecek
                    olan tahrişinde rahatlamasına yardımcı olur. Öksürüğün
                    şiddeti ve süresi de azalır. Su tüketiminin yanında çay
                    kahve gibi sıcak içeceklerin tüketimi de boğazda oluşan
                    tahrişin azaltılmasında yardımcı olur.
                  </li>
                  <li className="blue">
                    Öksürük şurupları ya da pastiller kullanılabilir. Kuru
                    öksürüğü azaltır ve boğazda oluşan tahrişi rahatlatır.
                  </li>
                  <li className="blue">
                    Öksürük dönemlerinde kişinin alerjisi yok ve 2 yaşın
                    üzerinde ise bal tüketimi hem boğaz yolunu rahatlatır hem de
                    öksürük krizlerini hafifletebilir.
                  </li>
                  <li className="blue">
                    Kişinin bulunduğu ortamı sıklıkla havalandırması da havanın
                    nemlenmesini ve temizlenmesi sağlayacağı için ortamdaki
                    alerjenleri de azaltmış olur. Oda nemlendiricileri havayı
                    nemlendirmek için iyi bir seçenek olabilir.
                  </li>
                  <li className="blue">
                    Tütün ve sigara dumanının bulunduğu ortamlar öksürüğü
                    alevlendirebileceği için bu tür ortamlarda bulunmaktan
                    kaçınılmalıdır. Pasif içicilik de sigara tüketimi gibi
                    akciğerleri tahriş eder ve alerjik öksürüğü artırabilir.
                    Sigara tüketiminin bırakılması konusunda çeşitli tedaviler
                    konusunda doktorunuz ile konuşabilirsiniz.
                  </li>
                </ul>
                <StaticImage
                  className={styles.image}
                  src="../../../images/cozum/alerjik-oksuruk/buhar-makinesi.webp"
                  alt="Buhar makinası görseli"
                  width={792}
                  height={430}
                />
                <p>
                  <br />
                  Alerjik öksürük, her kişide tamamen farklı faktörlerden
                  kaynaklandığından, tedavi seçeneklerinde de değişiklikler
                  mevcuttur:
                </p>
                <ul>
                  <li className="blue">
                    Vücudunuzun duyarlı olduğu alerjenlerden veya tahriş edici
                    maddelerden kaçınmak; en yaygın alerjenler polen, küf,
                    hayvan tüyü ve toz akarlarıdır.
                  </li>
                  <li className="blue">
                    Histamin salınımını engelleyen ve böylece burun tıkanıklığı,
                    burun akıntısı ve şişmiş burun geçişleri gibi semptomları
                    hafifleten antihistaminikler kullanılabilir,
                  </li>
                  <li className="blue">
                    Tıkalı ve burun akıntısını gideren dekonjestanlar
                    kullanılabilir,
                  </li>
                  <li className="blue">
                    Öksürük şiddetine bağlı olarak öksürük azaltıcı ilaçlar
                    kullanılabilir.
                  </li>
                </ul>
                <p>
                  Alerjik öksürük nadiren ciddi bir durumdur, ancak semptomları
                  çok rahatsız edici olabilir. Alerji uygun şekilde yönetilmezse
                  astım gelişme riski vardır. Bu nedenle, alerji semptomları çok
                  hafif olsa bile, 1 haftadan uzun süren ve iyileşmeyen
                  durumlarda, ateş ve balgam gibi durumlarda mutlaka hekim
                  kontrolüne başvurulması yararlı olacaktır.
                </p>
              </Level>
            </Level>
          </section>
        </div>
        <div className="date">
          <p>Yayınlama Tarihi: 2022-01-27</p>
          <p>Son güncellenme Tarihi: 2022-01-27</p>
        </div>
      </Container>
      <ProductBar />
    </Layout>
  );
};
export default CoughPage;